import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import BrowserPersistence from '@magento/peregrine/lib/util/simplePersistence';
import { removeCart } from '@magento/peregrine/lib/store/actions/cart';
import { clearCheckoutDataFromStorage } from '@magento/peregrine/lib/store/actions/checkout';
import actions from '@magento/peregrine/lib/store/actions/user/actions';
var storage = new BrowserPersistence();
export var signOut = function signOut() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _thunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var apolloClient, revokeToken;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              apolloClient = _ref.apolloClient;
              revokeToken = payload.revokeToken;

              if (!revokeToken) {
                _context.next = 11;
                break;
              }

              _context.prev = 3;
              _context.next = 6;
              return revokeToken();

            case 6:
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);
              console.error('Error Revoking Token', _context.t0);

            case 11:
              _context.next = 13;
              return dispatch(clearToken());

            case 13:
              _context.next = 15;
              return dispatch(actions.reset());

            case 15:
              _context.next = 17;
              return clearCheckoutDataFromStorage();

            case 17:
              _context.next = 19;
              return apolloClient.clearCacheData(apolloClient, 'cart');

            case 19:
              _context.next = 21;
              return apolloClient.clearCacheData(apolloClient, 'customer');

            case 21:
              _context.next = 23;
              return dispatch(removeCart());

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 8]]);
    }));

    function thunk(_x, _x2, _x3) {
      return _thunk.apply(this, arguments);
    }

    return thunk;
  }();
};
export var getUserDetails = function getUserDetails(_ref2) {
  var fetchUserDetails = _ref2.fetchUserDetails;
  return /*#__PURE__*/function () {
    var _thunk2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _len,
          args,
          _key,
          dispatch,
          getState,
          _getState,
          user,
          _yield$fetchUserDetai,
          data,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              for (_len = _args2.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args2[_key];
              }

              dispatch = args[0], getState = args[1];
              _getState = getState(), user = _getState.user;

              if (!user.isSignedIn) {
                _context2.next = 16;
                break;
              }

              dispatch(actions.getDetails.request());
              _context2.prev = 5;
              _context2.next = 8;
              return fetchUserDetails();

            case 8:
              _yield$fetchUserDetai = _context2.sent;
              data = _yield$fetchUserDetai.data;
              dispatch(actions.getDetails.receive(data.customer));
              _context2.next = 16;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](5);
              dispatch(actions.getDetails.receive(_context2.t0));

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5, 13]]);
    }));

    function thunk() {
      return _thunk2.apply(this, arguments);
    }

    return thunk;
  }();
};
export var resetPassword = function resetPassword(_ref3) {
  var email = _ref3.email;
  return /*#__PURE__*/function () {
    var _thunk3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _len2,
          args,
          _key2,
          dispatch,
          _args3 = arguments;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              for (_len2 = _args3.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = _args3[_key2];
              }

              dispatch = args[0];
              dispatch(actions.resetPassword.request()); // TODO: actually make the call to the API.
              // For now, just return a resolved promise.

              _context3.next = 5;
              return Promise.resolve(email);

            case 5:
              dispatch(actions.resetPassword.receive());

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function thunk() {
      return _thunk3.apply(this, arguments);
    }

    return thunk;
  }();
};
export var setToken = function setToken(token) {
  return /*#__PURE__*/function () {
    var _thunk4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _len3,
          args,
          _key3,
          dispatch,
          _args4 = arguments;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              for (_len3 = _args4.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = _args4[_key3];
              }

              dispatch = args[0]; // Store token in local storage.
              // TODO: Get correct token expire time from API

              storage.setItem('signin_token', token, 259200); // Persist in store

              dispatch(actions.setToken(token));

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function thunk() {
      return _thunk4.apply(this, arguments);
    }

    return thunk;
  }();
};
export var clearToken = function clearToken() {
  return /*#__PURE__*/function () {
    var _thunk5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _len4,
          args,
          _key4,
          dispatch,
          _args5 = arguments;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              for (_len4 = _args5.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = _args5[_key4];
              }

              dispatch = args[0]; // Clear token from local storage

              storage.removeItem('signin_token'); // Remove from store

              dispatch(actions.clearToken());

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function thunk() {
      return _thunk5.apply(this, arguments);
    }

    return thunk;
  }();
};